import './App.css';
import RegistrationForm from "./components/RegistrationForm/RegistrationForm";
import {Route, Routes} from "react-router-dom";
import PaymentInfo from "./components/PaymenInfo/PaymentInfo";

function App() {
  return (
    <div>
        <div>
            <Routes>
                <Route path='/payments/contact-form' element={<RegistrationForm/>} />
                <Route path='/payments/payment-info' element={<PaymentInfo/>} />
            </Routes>
        </div>
    </div>
  );
}

export default App;
